export default __webpack_public_path__ + "static/media/they-know-eye.4125ff97.png";